import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'preview/:key',
    loadComponent: () =>
      import('./features/slide-preview/slide-preview').then(m => m.SlidePreview),
  },
  {
    path: ':key',
    loadComponent: () =>
      import('./features/slide-player/slide-player').then(m => m.SlidePlayer),
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/slide-player/slide-player').then(m => m.SlidePlayer),
  },
];
